module.exports = __webpack_public_path__ + "static/media/w_y_45.10edac1f.png";